module.exports = __webpack_public_path__ + "static/media/Mcarousel3bg.a09b2343.png";